/**
 * HistoryAndPhysical class
 *
 * Used to store history and physical information about a patient.
 * This information is displayed in the "history and physical" tab under
 * provider charts.
 */

export class HistoryAndPhysical {
  [key: string]: string;
  allergies: string;
  cardiovascular: string;
  chiefComplaint: string;
  chiefInformant: string;
  contagiousDiseases: string;
  currentMeds: string;
  developmental: string;
  dietaryHistory: string;
  endocrine: string;
  familyHistory: string;
  gastrointestinal: string;
  genitourinary: string;
  heent: string;
  histOfCurrProb: string;
  impressions: string;
  impressionsDay: string;
  injuries: string;
  integument: string;
  lymphatic: string;
  musculoskeletal: string;
  neurologic: string;
  otherPastMedHist: string;
  plan: string;
  previousIllness: string;
  provSignature: string;
  respiratory: string;
  socialHistory: string;
  surgicalHistory: string;
  // below are variables pertaining to physical examination
  peCardio: string;
  peDevelopmental: string;
  peEndocrine: string;
  peGastrointestinal: string;
  peGeneral: string;
  peGenitourinary: string;
  peHEENT: string;
  peLymphatic: string;
  peMusculoskeletal: string;
  peNeurologic: string;
  peRespiratory: string;
  peSkin: string;
  peVitalSigns: string;
  peProviderNotified: string;

  // The order of the parameters in the constructor matters.
  // Please do not re-arrange because they are based on the order of
  // paramaters that the nursing professor has to fill out in the CSV template
  constructor() {
    this.allergies = '';
    this.cardiovascular = '';
    this.chiefComplaint = '';
    this.chiefInformant = '';
    this.contagiousDiseases = '';
    this.currentMeds = '';
    this.developmental = '';
    this.dietaryHistory = '';
    this.endocrine = '';
    this.familyHistory = '';
    this.gastrointestinal = '';
    this.genitourinary = '';
    this.heent = '';
    this.histOfCurrProb = '';
    this.impressions = '';
    this.impressionsDay = '';
    this.injuries = '';
    this.integument = '';
    this.lymphatic = '';
    this.musculoskeletal = '';
    this.neurologic = '';
    this.otherPastMedHist = '';
    this.plan = '';
    this.previousIllness = '';
    this.provSignature = '';
    this.respiratory = '';
    this.socialHistory = '';
    this.surgicalHistory = '';
    // below are propoerties pertaining to Physical Examination.
    // again, please do not rearrange.
    this.peCardio = '';
    this.peDevelopmental = '';
    this.peEndocrine = '';
    this.peGastrointestinal = '';
    this.peGeneral = '';
    this.peGenitourinary = '';
    this.peHEENT = '';
    this.peLymphatic = '';
    this.peMusculoskeletal = '';
    this.peNeurologic = '';
    this.peRespiratory = '';
    this.peSkin = '';
    this.peVitalSigns = '';
    this.peProviderNotified = '';
  }
  // start getters for history and physical information
  // getAllergies(): string { return this.allergies; }
  // getCardiovascular(): string { return this.cardiovascular; }
  // getChiefComplaint(): string { return this.chiefComplaint; }
  // getContagiousDiseases(): string { return this.contagiousDiseases; }
  // getCurrentMeds(): string { return this.currentMeds; }
  // getDevelopmental(): string { return this.developmental; }
  // getDietHistory(): string { return this.dietHistory; }
  // getEndocrine(): string { return this.endocrine; }
  // getFamilyHistory(): string { return this.familyHistory; }
  // getGastrointestinal(): string { return this.gastrointestinal; }
  // getGenitoUrinary(): string { return this.genitourinary; }
  // getHEENT(): string { return this.heent; }
  // getHistOfCurrProb(): string { return this.histOfCurrProb; }
  // getImpressions(): string { return this.impressions; }
  // getImpressionsDay(): string { return this.impressionsDay; }
  // getInformant(): string { return this.informant; }
  // getInjuries(): string { return this.injuries; }
  // getIntegument(): string { return this.integument; }
  // getLymphatic(): string { return this.lymphatic; }
  // getMusculoskeletal(): string { return this.musculoskeletal; }
  // getNeurologic(): string { return this.neurologic; }
  // getOtherPastMedHist(): string { return this.otherPastMedHist; }
  // getPlan(): string { return this.plan; }
  // getPreviousIllnesses(): string { return this.previousIllnesses; }
  // getProvSignature(): string { return this.provSignature; }
  // getRespiratory(): string { return this.respiratory; }
  // getSocialHistory(): string { return this.socialHistory; }
  // getSurgicalHistory(): string { return this.surgicalHistory; }
}
